const calcHieght = {
    grid: document.querySelectorAll(".jsCalcHeightCont") as NodeListOf<HTMLElement>,
    init() {      
        this.resizeAllGridItems()   
    },
    resizeGridItem(rowGap: number,rowHeight:number, item: HTMLElement) {       
        let child = item.firstElementChild as HTMLElement;
        let rowSpan = Math.ceil((child.offsetHeight + rowGap) / (rowHeight + rowGap));
        item.style.gridRowEnd = "span " + rowSpan;
     
    },

    resizeAllGridItems() {
        this.grid.forEach(cont => {
         
            let rowHeight = parseInt(getComputedStyle(cont).getPropertyValue('grid-auto-rows'));
            let rowGap = parseInt(getComputedStyle(cont).getPropertyValue('grid-row-gap'));    
            let allItems = document.querySelectorAll(".jsCalcHeightItem") as NodeListOf<HTMLElement>;
            if(allItems.length > 0) {
                allItems.forEach((item) => {
                    this.resizeGridItem(rowGap,rowHeight, item);
                })
            }
       
       })

    },

}

export default calcHieght;